import TrashIcon from '@/assets/img/delete-icon.svg?react'
import { useEffect, useState } from 'react'
import Button from './Button'

interface FuncProps {
    onChange?: (file: File | null) => void
    userPhoto?: string | null
    type?: 'photo-load-rectangle' | 'photo-load'
    error?: string
    accept?: string
}

export const ChangePhotoPart: React.FC<FuncProps> = ({
    onChange,
    userPhoto,
    type = 'photo-load',
    error,
    accept = 'image/*',
}) => {
    const [file, setFile] = useState<File | null>(null)

    const changePhoto = (selectedFile: File) => {
        setFile(selectedFile)
        if (onChange) {
            onChange(selectedFile)
        }
    }
    useEffect(() => {
        if (userPhoto) {
            fetch(userPhoto)
                .then(async res => res.blob())
                .then(blob => {
                    const initialFile = new File([blob], 'user_photo.jpg', {
                        type: blob.type,
                    })
                    setFile(initialFile)
                })
                .catch(error =>
                    console.error('Error fetching the image:', error),
                )
        }
    }, [userPhoto])

    useEffect(() => {
        return () => {
            if (file) {
                URL.revokeObjectURL(URL.createObjectURL(file))
            }
        }
    }, [file])

    return (
        <>
            <div className="upload-photo">
                <div className={type}>
                    {file ? (
                        <img
                            src={URL.createObjectURL(file)}
                            alt=""
                        />
                    ) : (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={20}
                            height={20}
                            viewBox="0 0 448 512"
                        >
                            <path d="M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464l349.5 0c-8.9-63.3-63.3-112-129-112l-91.4 0c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z" />
                        </svg>
                    )}
                </div>
                <div className="upload-control-group">
                    <label className="upload-control">
                        <input
                            type="file"
                            hidden
                            accept={accept}
                            onChange={e => {
                                const selectedFile =
                                    e.target.files && e.target.files[0]
                                if (selectedFile) {
                                    changePhoto(selectedFile)
                                }
                            }}
                        />
                        <div className="btn btn--secondary btn--sm radius">
                            <span>Change Photo</span>
                        </div>
                    </label>
                    {file && (
                        <Button
                            square
                            variant="danger"
                            size="sm"
                            onClick={() => {
                                setFile(null)
                                if (onChange) {
                                    onChange(null)
                                }
                            }}
                        >
                            <TrashIcon />
                        </Button>
                    )}
                </div>
            </div>
            {error && (
                <label className="form-label">
                    <div
                        className="label--text"
                        style={{ color: 'var(--danger)' }}
                    >
                        <span>{error}</span>
                    </div>
                </label>
            )}
        </>
    )
}
